/**
 * Every reason a stop can carry, in the order a dispatcher scans them.
 *
 * Kept in step with core/dwell_engine.DWELL_REASONS, which is itself kept in
 * step with dwell_records.reason's CHECK constraint in schema.sql. A value
 * that is not in all three is refused by the database, so a picker offering
 * one would produce a 400 the dispatcher cannot act on.
 *
 * Ordered by how often a tipper haulier actually meets them rather than
 * alphabetically or by schema order: a queue and a missing load are most of
 * a month's waiting, and "other" belongs last because it is the answer given
 * when none of the ones above fit.
 *
 * `null` is deliberately NOT in this list. It is a real state on a row — a
 * stop nobody explained — and it is rendered as such, but it is not an
 * option: the route requires a reason, and "un-explain this stop" is not an
 * act anybody needs.
 */
export const DWELL_REASONS = [
  'queue',
  'no_material',
  'unloading_delay',
  'scale_issue',
  'breakdown',
  'other',
];
